import * as React from "react";

import { Section } from "@/components/Section";
import { Container } from "@/components/Container";
import { Eyebrow } from "@/components/Eyebrow";

export interface LegalPageProps {
  eyebrow: string;
  title: string;
  lastUpdated: string;
  intro?: string;
  children: React.ReactNode;
}

/**
 * Shared shell for the legal pages: narrow measure, generous rhythm,
 * one h1, and a visible last-updated line above the body copy.
 */
export function LegalPage({ eyebrow, title, lastUpdated, intro, children }: LegalPageProps) {
  return (
    <Section>
      <Container variant="narrow">
        <Eyebrow>{eyebrow}</Eyebrow>
        <h1 className="mt-4 font-display text-display-lg text-ink-900 text-balance">{title}</h1>
        <p className="mt-4 font-mono text-body-sm uppercase tracking-[0.14em] text-ink-500">
          Last updated: {lastUpdated}
        </p>
        {intro ? <p className="mt-6 text-body-lg text-ink-600">{intro}</p> : null}
        <div className="legal-prose mt-12">{children}</div>
      </Container>
    </Section>
  );
}

export function LegalSection({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="mt-12 first:mt-0">
      <h2 className="font-display text-h3 text-ink-900">{title}</h2>
      <div className="mt-4 space-y-4">{children}</div>
    </section>
  );
}

export default LegalPage;
